import withQuillLayout from 'src/_common/hoc/QuillLayout';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/_common/models/redux/store';
import { DocumentContext } from 'next/document';
import { PlanInterface, PriceContext } from 'src/payments/models/paymentFlow';
import { Typography, Grid, Box, styled } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import CommonLoading from 'src/_common/quillElements/spinner/Loading';
import SuccessPaymentPage from 'src/payments/components/SuccessPaymentPage';
import getConfig from 'next/config';
import { DEVICE_VIEWPORTS } from 'config/constants';
import LoadingLockFull from 'src/_common/quillElements/spinner/LoadingLockFull';
import QuillLocalStorage from 'core/utils/localStorageClient';
import PaymentSwipeView from 'src/payments/components/paymentFlowScreens';
// import paymentReducers from 'src/payments/reducers';
// import { ReduxStore } from 'src/_common/redux/store';
import UpgradeComparisonB from 'src/payments/components/UpgradeComparisonB';
import ChargebeeClient from 'src/payments/utils/chargebeeClient';
import { PaymentMethodsContext, PaymentProviders } from 'src/payments/models/payments';

const { serverRuntimeConfig } = getConfig();

const useStyles = makeStyles((theme) => ({
  checkoutTitle: {
    display: 'none',
    fontSize: '30px',
    fontWeight: 600,
    margin: '0px 0px 3px 0px ',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      margin: '25px auto 27px',
      textAlign: 'center',
      fontWeight: 600,
      padding: '0px 25px',
      fontSize: '25px',
    },
    [theme.breakpoints.down(400)]: {
      maxWidth: '330px',
    },
  },

  planContainer: {
    marginTop: '30px',
    padding: '35px 35px 40px',
    // backgroundColor: theme.specialColors.CHECKOUT_PAGE_BG,
    [theme.breakpoints.down('lg')]: {
      padding: '20px 5px 40px',
    },

    [theme.breakpoints.down('md')]: {
      padding: '20px 0px 40px',
      flexDirection: 'column-reverse',
    },
  },
  checkoutMainHolder: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '11px',
      paddingRight: '11px',
      paddingBottom: '40px',
      marginTop: '0px',
      overflow: 'hidden',
    },
    [theme.breakpoints.down(460)]: {
      marginBottom: '-41px',
    },
  },
  upgradeContainer: {
    [theme.breakpoints.down('md')]: {
      // maxWidth: '500px',
      margin: '0px auto',
    },
  },
  chackoutSmallText: {
    fontSize: '10px',
    maxWidth: '496px',
    margin: '15px 0px 0px',
    textAlign: 'left',
  },
  paymentMainHolder: {
    [theme.breakpoints.down('md')]: {
      marginBottom: '0px',
    },
  },

  paymentMainInnerHolder: {
    [theme.breakpoints.down('md')]: {
      maxWidth: '476px',
      margin: 'auto',
    },
  },

  languageBoxMain: {
    maxWidth: '530px',
    [theme.breakpoints.down('md')]: {
      margin: 'auto',
    },
  },
}));

const StyledContainer = styled('div')`
  max-width: 1170px;
  margin-bottom: 30px;

  @media ${DEVICE_VIEWPORTS.md} {
    margin-bottom: 0px;
    margin-top: -30px;
    padding: 0px 0px;
  }
  @media ${DEVICE_VIEWPORTS.sm} {
    margin-bottom: 0px;
    margin-top: -30px;
    padding: 0px 0px;
  }

  @media ${DEVICE_VIEWPORTS.xs} {
    margin-bottom: 0px;
    margin-top: -30px;
    padding: 0px 0px;
  }
`;

function Upgrade({
  prices,
  forcePlan,
  isPaypalReturn,
  paymentMethods,
}: {
  prices: Array<PlanInterface>;
  forcePlan: number;
  isPaypalReturn: boolean;
  paymentMethods: Record<string, boolean>;
}) {
  // const store: ReduxStore = useStore();
  // store?.injectAsyncReducer('pymt', paymentReducers);
  const classes = useStyles();
  const isLoading = useSelector((state: RootState) => state.pymt.isLoading);
  const isPaymentSucess = useSelector((state: RootState) => state.pymt?.isPaymentSucess);
  const syncedWithDb = useSelector((state: RootState) => state.user?.syncedWithDb);
  const isUnderMaintenance = useSelector(
    (state: RootState) => state.common?.maintenance?.globalMaintenance?.enabled
  );
  const selectedPlan = QuillLocalStorage.getInstance().get('selectedPlan');
  const [forcePlanState, setForcePlanState] = useState<number | null>(forcePlan);

  useEffect(() => {
    if (selectedPlan && isPaypalReturn) {
      setForcePlanState(Number(selectedPlan));
    }
    ChargebeeClient.getInstance();
  }, []);

  return (
    <PriceContext.Provider value={prices}>
      <PaymentMethodsContext.Provider value={paymentMethods}>
        {isPaymentSucess ? (
          <SuccessPaymentPage planDetails={prices[Number(selectedPlan)]} show={isPaymentSucess} />
        ) : (
          <StyledContainer className="container">
            <Box className={classes.upgradeContainer}>
              <Grid container className={classes.planContainer}>
                <Grid item xs={12} sm={12} md={6} lg={6} className={classes.checkoutMainHolder}>
                  <Box className={classes.languageBoxMain}>
                    <Typography className={classes.checkoutTitle} variant="h2">
                      Gain the full power of QuillBot
                    </Typography>
                    {/* <CheckoutPremiumProp /> */}
                    {/* <p className={classes.chackoutSmallText}>
                    *Results from a QuillBot survey taken in December 2020.
                  </p> */}
                    <UpgradeComparisonB />
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} className={classes.paymentMainHolder}>
                  <Box className={classes.paymentMainInnerHolder}>
                    <PaymentSwipeView forcePlan={forcePlanState} />
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <LoadingLockFull isLoading={isLoading} />
          </StyledContainer>
        )}
        <CommonLoading isLoading={!syncedWithDb && !isUnderMaintenance} />
      </PaymentMethodsContext.Provider>
    </PriceContext.Provider>
  );
}

export async function getServerSideProps({ req, query }: DocumentContext) {
  const xForwaredFor = (() => {
    /* if (req?.headers['x-forwarded-for']) {
      if (typeof req?.headers['x-forwarded-for'] === 'string') {
        return req?.headers['x-forwarded-for']?.split(',').pop()?.trim();
      }
      if (typeof req?.headers['x-forwarded-for'] === 'object') {
        return req?.headers['x-forwarded-for'].pop()?.trim();
      }
    } */
    const ip =
      req?.headers['x-forwarded-for'] ||
      req?.connection?.remoteAddress ||
      req?.socket.remoteAddress ||
      '';
    if (ip) {
      if (ip.includes(',') && typeof ip === 'string') {
        const splitIp = (ip as string)?.split(',');
        return splitIp[0].trim();
      }
      if (Array.isArray(ip)) {
        return ip[0]?.trim();
      }
      return ip;
    }
    return null;
  })();

  let prices: Array<PlanInterface> = [];
  let paymentMethods: Record<string, boolean>;
  let pricesSet = false;
  try {
    const [priceResponse, methodsResponse] = await Promise.all([
      fetch(
        `${serverRuntimeConfig.REST_SERVER_DIRECT_URL}/api/payments/get-pricing?ip=${
          xForwaredFor || ''
        }`
      ),
      fetch(
        `${serverRuntimeConfig.REST_SERVER_DIRECT_URL}/api/payments/available-payment-methods?ip=${
          xForwaredFor || ''
        }`
      ),
    ]);

    const unsanatizedPlans: { code: number; prices: number[]; discounts: number[] } = (
      await priceResponse.json()
    ).data;

    if (unsanatizedPlans) {
      prices = [
        {} as any, // padding given to match array with planIDs since the plan id is 1 2 3 an extra entry just cleans everything out
        {
          title: 'Monthly',
          duration: 1,
          price: unsanatizedPlans.prices[0],
          country: unsanatizedPlans.code,
          featured: false,
          id: 1,
        },
        {
          title: 'Semi-Annual',
          price: unsanatizedPlans.prices[1],
          monthlyPrice: unsanatizedPlans.prices[2],
          saving: unsanatizedPlans.discounts[0],
          duration: 6,
          country: unsanatizedPlans.code,
          featured: false,
          id: 2,
        },
        {
          title: 'Annual',
          price: unsanatizedPlans.prices[3],
          monthlyPrice: unsanatizedPlans.prices[4],
          duration: 12,
          country: unsanatizedPlans.code,
          saving: unsanatizedPlans.discounts[1],
          featured: true,
          id: 3,
        },
      ];
    } else {
      prices = [];
    }
    pricesSet = true;
    // get payment methods
    const paymentMethodsResponse = (await methodsResponse.json()).data;
    if (paymentMethodsResponse) {
      // deleting false keys
      Object.keys(paymentMethodsResponse).forEach((key) => {
        if (!paymentMethodsResponse[key]) delete paymentMethodsResponse[key];
      });
    }
    if (paymentMethodsResponse && Object.keys(paymentMethodsResponse).length > 0) {
      paymentMethods = paymentMethodsResponse;
    } else {
      paymentMethods = {
        [PaymentProviders.CHARGEBEE_STRIPE]: true,
        [PaymentProviders.CHARGEBEE_PAYPAL]: true,
      };
    }
  } catch (e) {
    prices = pricesSet ? prices : [];
    paymentMethods = {
      [PaymentProviders.CHARGEBEE_STRIPE]: true,
      [PaymentProviders.CHARGEBEE_PAYPAL]: true,
    };
  }
  return {
    props: {
      prices,
      paymentMethods,
      forcePlan: Number(query.plan) || null,
      isPaypalReturn: (query.token && query.ba_token) || false,
    },
  };
}

export default withQuillLayout({
  children: Upgrade,
});
